/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PendingVerificationLegalEntityResource } from './';
import {
    PendingVerificationLegalEntityResourceFromJSON,
    PendingVerificationLegalEntityResourceFromJSONTyped,
    PendingVerificationLegalEntityResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface PendingVerificationLegalEntitySearchResultResource
 */
export interface PendingVerificationLegalEntitySearchResultResource {
    /**
     * 
     * @type {Array<PendingVerificationLegalEntityResource>}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    items: Array<PendingVerificationLegalEntityResource>;
    /**
     * 
     * @type {number}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    hasNext: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    hasPrevious: boolean;
    /**
     * 
     * @type {number}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PendingVerificationLegalEntitySearchResultResource
     */
    pageSize: number;
}

/**
 * Check if a given object implements the PendingVerificationLegalEntitySearchResultResource interface.
 */
export function instanceOfPendingVerificationLegalEntitySearchResultResource(value: object): value is PendingVerificationLegalEntitySearchResultResource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('hasNext' in value) || value['hasNext'] === undefined) return false;
    if (!('hasPrevious' in value) || value['hasPrevious'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function PendingVerificationLegalEntitySearchResultResourceFromJSON(json: any): PendingVerificationLegalEntitySearchResultResource {
    return PendingVerificationLegalEntitySearchResultResourceFromJSONTyped(json, false);
}

export function PendingVerificationLegalEntitySearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingVerificationLegalEntitySearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PendingVerificationLegalEntityResourceFromJSON)),
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
        'hasNext': json['hasNext'],
        'hasPrevious': json['hasPrevious'],
        'page': json['page'],
        'pageSize': json['pageSize'],
    };
}

export function PendingVerificationLegalEntitySearchResultResourceToJSON(value?: PendingVerificationLegalEntitySearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => PendingVerificationLegalEntityResourceToJSON(v))),
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
        'hasNext': value['hasNext'],
        'hasPrevious': value['hasPrevious'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

